import { useEffect, useRef, useState } from 'react';
import ReactModal from 'react-modal';
import Avatar, { genConfig } from 'funifier-nice-avatar';
import AvatarEditor from 'react-avatar-editor';
import Dropzone from 'react-dropzone';
import { IoIosClose } from 'react-icons/io';
import { useModal } from 'context/ModalContext';
import { uploadPicture, updateUserProfile } from 'services/profile.service';
import { useAuth } from 'context/AuthContext';
import { toast } from 'react-toastify';
// import { BiTrash } from 'react-icons/bi';
// import { FaRegTrashAlt } from 'react-icons/fa';
import { GrTrash } from 'react-icons/gr';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { AvatarConfig, GetAvatarDefaultOptions } from './config';

import noImage from 'assets/img/no-image.png';
import { RiImageEditFill } from 'react-icons/ri';
import { updateUserPass } from 'services/auth.service';

const config = genConfig();

const avatarDefaultOptions = GetAvatarDefaultOptions() as any;

let imagePreviewTimeout: any = null;

export function AvatarModal(props: any) {
  // const modalID = "achievement";

  const { user, refreshUser } = useAuth();

  const modalID = 'avatar';

  const senhaAtualRef = useRef<any>();
  const novaSenhaRef = useRef<any>();
  const confirmarNovaSenhaRef = useRef<any>();

  const [senhaAtual, setSenhaAtual] = useState<any>();
  const [novaSenha, setNovaSenha] = useState<any>();
  const [confirmarNovaSenha, setConfirmarNovaSenha] = useState<any>();
  const [typeInput1, setTypeInput1] = useState<'password' | 'text'>('password');
  const [typeInput2, setTypeInput2] = useState<'password' | 'text'>('password');
  const [typeInput3, setTypeInput3] = useState<'password' | 'text'>('password');
  const [passError, setPassError] = useState<string>();

  const [loading, setLoading] = useState(false);

  const [modalIsOpen, setIsOpen] = useState(false);
  const [avatarConfig, setAvatarConfig] = useState<AvatarConfig>(config);

  const { openModal, modalData, closeModal } = useModal();

  const [avatarType, setAvatarType] = useState(0);

  const [image, setImage] = useState('');
  const editor = useRef<any>(null);

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    setImage('');
    setLoading(false);
    setAvatarType(0);
    setTypeInput1('password');
    setTypeInput2('password');
    setTypeInput3('password');
    setSenhaAtual(undefined);
    setNovaSenha(undefined);
    setConfirmarNovaSenha(undefined);
    setPassError(undefined);
    closeModal();
  }

  function afterOpenModal() {}

  async function handleNewPass() {
    if (typeof senhaAtual !== 'string' || !senhaAtual.trim().length) {
      return setPassError('Por favor, preencha o campo senha corretamente.');
    } else if (typeof novaSenha !== 'string' || !novaSenha.trim().length) {
      return setPassError('Por favor, preencha o campo nova senha corretamente.');
    } else if (typeof confirmarNovaSenha !== 'string' || !confirmarNovaSenha.trim().length) {
      return setPassError('Por favor, preencha o campo confirmar nova senha corretamente.');
    } else if (novaSenha.trim() !== confirmarNovaSenha.trim()) {
      return setPassError('A nova senha precisa ser idêntica à confirmação da nova senha.');
    } else if (!!senhaAtual.match(/ /gi) || !!novaSenha.match(/ /gi) || !!confirmarNovaSenha.match(/ /gi)) {
      return setPassError('As senhas não podem conter espaços.');
    } else if (novaSenha.trim() === senhaAtual.trim()) {
      return setPassError('A nova senha precisa ser diferente da senha antiga.');
    }

    setPassError(undefined);
    setLoading(true);

    try {
      const resp = await updateUserPass(senhaAtual.trim(), novaSenha.trim());
      if (resp?.data?.code === 200) {
        handleCloseModal();
        toast(`👍 Sua senha foi atualizada com sucesso!`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        setPassError('Não foi possível alterar a senha. Por favor, verifique os dados e tente novamente.');
      }
    } catch (error) {
      setPassError('Não foi possível alterar a senha. Por favor, verifique os dados e tente novamente.');
    }

    setLoading(false);
  }

  async function handleUpload() {
    if (avatarType === 2) {
      return handleNewPass();
    }

    let profileImage: any = {};

    setLoading(true);

    if (image) {
      const dataUrl = editor.current.getImageScaledToCanvas().toDataURL();

      if (dataUrl) {
        const uploadResult = await uploadPicture(dataUrl);

        if (uploadResult) {
          const url = uploadResult.url;
          profileImage = {
            image: {
              small: { url },
              medium: { url },
              original: { url },
            },
          };
        }
      }
    }

    profileImage['extra'] = {
      ...user?.extra,
      avatar_type: avatarType,
      avatar: avatarConfig,
    };

    if (profileImage) {
      // console.log(profileImage);
      if (!user) return;
      await updateUserProfile({ _id: user._id, ...profileImage });
      refreshUser();
      handleCloseModal();
      toast(`👍 Seu perfil foi atualizado com sucesso!`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  function handleImageChange() {
    if (imagePreviewTimeout) {
      clearTimeout(imagePreviewTimeout);
    }

    imagePreviewTimeout = setTimeout(() => {
      getImageUrl();
    }, 1000);
  }

  function handleClearImage() {
    const profileImage = document.getElementById('profile-image');
    if (profileImage) {
    }
    setImage('');
  }

  const getImageUrl = async () => {
    if (!editor.current) return;

    const dataUrl = editor.current.getImageScaledToCanvas().toDataURL();
    const result = await fetch(dataUrl);
    const blob = await result.blob();

    const profileImage = document.getElementById('profile-image');
    if (profileImage) {
      profileImage.style.backgroundImage = `url(${window.URL.createObjectURL(blob)})`;
    }

    // return window.URL.createObjectURL(blob)
  };

  function getImagePlaceHolder() {
    if (!image && user && user.image && user.image.medium) {
      return { backgroundImage: `url(${user.image.medium.url})` };
    } else
      return {
        backgroundImage: `url(${noImage})`,
        backgroundSize: 'cover',
      };
  }

  // function switchAvatarPart(part: string) {
  //   const newAvatarConfig = { ...avatarConfig };
  //   console.log(newAvatarConfig);
  //   setAvatarConfig(newAvatarConfig);
  // }

  function switchAvatarPart(type: string, currentOpt?: any) {
    const opts: any = avatarDefaultOptions[type];
    const currentIdx = opts.findIndex((item: any) => item === currentOpt);
    const newIdx = (currentIdx + 1) % opts.length;
    const newAvatarConfig = { ...avatarConfig, [type]: opts[newIdx] };

    if (type === 'hairStyle') {
      newAvatarConfig['hatStyle'] = 'none';
    }

    setAvatarConfig(newAvatarConfig);
  }

  useEffect(() => {
    if (!user) return;

    setIsOpen(openModal === modalID);

    if (modalData && modalData.config) {
      setAvatarConfig(modalData.config);

      if (user.extra.avatar_type) {
        setAvatarType(user.extra.avatar_type);
      }
    }
  }, [user, openModal, modalData]);

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        contentLabel="Example Modal"
        portalClassName="relative z-50"
        overlayClassName="rb-modal-overlay"
        contentElement={() => (
          <div className="rb-modal rb-modal--sm">
            <button className="rb-modal__close" aria-label="Fechar" onClick={() => handleCloseModal()}>
              <IoIosClose size={26} />
            </button>

            <div className="rb-modal__header">
              <h1 className="rb-modal__title">Editar perfil</h1>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center', marginBottom: 20 }}>
              <button
                className={`rb-toggle ${avatarType === 0 ? 'rb-toggle--on' : 'rb-toggle--off'}`}
                onClick={() => setAvatarType(0)}
                disabled={loading}
              >
                Avatar
              </button>
              <button
                className={`rb-toggle ${avatarType === 1 ? 'rb-toggle--on' : 'rb-toggle--off'}`}
                onClick={() => setAvatarType(1)}
                disabled={loading}
              >
                Imagem
              </button>
              <button
                className={`rb-toggle ${avatarType === 2 ? 'rb-toggle--on' : 'rb-toggle--off'}`}
                onClick={() => setAvatarType(2)}
                disabled={loading}
              >
                Alterar senha
              </button>
            </div>

            <div className="flex flex-col items-center">
              {avatarType === 0 && (
                <div className="flex flex-col items-center w-full">
                  <Avatar className="w-36 h-36" {...avatarConfig} />

                  <div className="flex-1 mt-3 grid grid-cols-3 flex-wrap gap-2 w-full">
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('faceColor', avatarConfig.faceColor)}>
                      Pele
                    </button>
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('eyeStyle', avatarConfig.eyeStyle)}>
                      Olhos
                    </button>
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('glassesStyle', avatarConfig.glassesStyle)}>
                      Óculos
                    </button>
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('earSize', avatarConfig.earSize)}>
                      Orelhas
                    </button>
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('mouthStyle', avatarConfig.mouthStyle)}>
                      Boca
                    </button>
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('noseStyle', avatarConfig.noseStyle)}>
                      Nariz
                    </button>
                  </div>

                  <div className="flex-1 mt-2 grid grid-cols-2 flex-wrap gap-2 w-full">
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('hairStyle', avatarConfig.hairStyle)}>
                      Cabelo
                    </button>
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('hairColor', avatarConfig.hairColor)}>
                      Cor do Cabelo
                    </button>
                  </div>

                  <div className="flex-1 w-full mt-2 grid grid-cols-2 flex-wrap gap-2">
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('hatStyle', avatarConfig.hatStyle)}>
                      Acessório
                    </button>
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('hatColor', avatarConfig.hatColor)}>
                      Cor do Acc.
                    </button>
                  </div>

                  <div className="flex-1 mt-2 grid grid-cols-3 flex-wrap gap-2 w-full">
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('shirtStyle', avatarConfig.shirtStyle)}>
                      Camisa
                    </button>
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('shirtColor', avatarConfig.shirtColor)}>
                      Cor
                    </button>
                    <button className="rb-btn-ghost" onClick={() => switchAvatarPart('bgColor', avatarConfig.bgColor)}>
                      Fundo
                    </button>
                  </div>
                </div>
              )}

              {avatarType === 1 && (
                <div>
                  <div
                    className="rounded-full relative z-2 mt-2 rounded-lg bg-gray-100 w-64 h-64"
                    style={getImagePlaceHolder()}
                    title={!image && user && user.image && user.image.medium ? 'Enviar nova imagem' : undefined}
                  >
                    <Dropzone
                      onDrop={(dropped: any) => setImage(dropped[0])}
                      multiple={false}
                      maxFiles={1}
                      noClick={!!image}
                      accept={{
                        'image/png': ['.png', '.jpeg', '.jpg', '.gif'],
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps()} className={`${!image ? '!cursor-pointer' : ''}`}>
                          <AvatarEditor
                            ref={e => (editor.current = e)}
                            onImageChange={handleImageChange}
                            width={256}
                            height={256}
                            image={image}
                            borderRadius={256}
                            border={0}
                            className={`overflow-hidden rounded-full ${!image ? '!cursor-pointer' : ''}`}
                          />
                          <input {...getInputProps()} />
                        </div>
                      )}
                    </Dropzone>
                    {!!image ? (
                      <button
                        type="button"
                        onClick={handleClearImage}
                        className="absolute bottom-[5px] right-[5px] rounded-full flex flex-row items-center justify-center text-red-500 bg-white w-[40px] h-[40px]"
                        title="Excluir"
                      >
                        X
                      </button>
                    ) : null}
                    {!image && user && user.image && user.image.medium ? (
                      <button
                        type="button"
                        onClick={handleClearImage}
                        className="pointer-events-none absolute bottom-[5px] right-[5px] rounded-full flex flex-row items-center justify-center text-red-500 bg-white w-[40px] h-[40px]"
                        title="Enviar nova imagem"
                      >
                        <RiImageEditFill size={25} />
                      </button>
                    ) : null}
                  </div>
                </div>
              )}

              {avatarType === 2 && (
                <div className="w-full">
                  <div className="rb-modal__field">
                    <label className="rb-modal__label">Senha atual</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        type={typeInput1}
                        ref={ref => (senhaAtualRef.current = ref)}
                        onChange={e => setSenhaAtual(e.target.value)}
                        className="rb-input"
                        style={{ paddingRight: 42 }}
                        name="actualPass"
                        id="actualPass"
                      />
                      <button
                        type="button"
                        onClick={() => setTypeInput1(lastVal => (lastVal === 'password' ? 'text' : 'password'))}
                        style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--color-text-muted)' }}
                      >
                        {typeInput1 === 'password' ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                      </button>
                    </div>
                  </div>

                  <div className="rb-modal__field">
                    <label className="rb-modal__label">Nova senha</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        type={typeInput2}
                        ref={ref => (novaSenhaRef.current = ref)}
                        onChange={e => setNovaSenha(e.target.value)}
                        className="rb-input"
                        style={{ paddingRight: 42 }}
                        name="newPass"
                        id="newPass"
                      />
                      <button
                        type="button"
                        onClick={() => setTypeInput2(lastVal => (lastVal === 'password' ? 'text' : 'password'))}
                        style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--color-text-muted)' }}
                      >
                        {typeInput2 === 'password' ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                      </button>
                    </div>
                  </div>

                  <div className="rb-modal__field">
                    <label className="rb-modal__label">Confirmar nova senha</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        type={typeInput3}
                        ref={ref => (confirmarNovaSenhaRef.current = ref)}
                        onChange={e => setConfirmarNovaSenha(e.target.value)}
                        className="rb-input"
                        style={{ paddingRight: 42 }}
                        name="confirmNewPass"
                        id="confirmNewPass"
                      />
                      <button
                        type="button"
                        onClick={() => setTypeInput3(lastVal => (lastVal === 'password' ? 'text' : 'password'))}
                        style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--color-text-muted)' }}
                      >
                        {typeInput3 === 'password' ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                      </button>
                    </div>
                  </div>

                  {typeof passError === 'string' && passError.length && (
                    <p className="rb-modal__text" style={{ textAlign: 'center', color: 'var(--blue-primary)' }}>
                      {passError}
                    </p>
                  )}
                </div>
              )}
            </div>

            {loading && (
              <p className="rb-modal__text" style={{ textAlign: 'center', marginTop: 20 }}>
                Salvando alterações...
              </p>
            )}

            {!loading && (
              <div className="rb-modal__actions">
                <button className="rb-btn-ghost" onClick={() => handleCloseModal()}>
                  Cancelar
                </button>
                <button className="rb-btn-primary" onClick={() => handleUpload()}>
                  Salvar
                </button>
              </div>
            )}
          </div>
        )}
      />
    </>
  );
}
